import appGlobalScript from '/tmp/builds/5MRsrR2d8/3/TRUMPF-corp/trumpf-ux/features/com.trumpf.ux.ui-core/packages/ux-ui/src/globals/ux.ui.core.ts';
export const globalScripts = appGlobalScript;
